import { getEndpointUrl } from "../utils/endPoints";
import { handleRequest } from "../utils/httpRequest";
import generalController from "./generalController";
import { Dealer, Vehicle } from "../types";

// Formatted vehicle data from API
interface VehicleDataFormatted {
  id: number;
  isEV: boolean;
  title: string;
  slug: string;
  model: string;
  msrp: number;
  year: string;
  description: string;
  visual: {
    jelly: string;
    jelly_hover: string;
    jelly_path: string;
    [key: string]: any;
  };
}

// API response for model search
interface ModelSearchResponse {
  model_year: {
    id: number;
    is_ev: boolean;
    description: string;
    jelly: string;
    jelly_hover: string;
    jelly_path: string;
  };
  carline: {
    title: string;
    url_slug: string;
    voi_leads_name: string;
  };
  financial: {
    msrp: number;
  };
  year: {
    url_slug: string;
  };
  visual: {
    [key: string]: any;
  };
}

// Dealer data with user position
interface DealerDataWithPosition {
  dealer: Dealer;
  userPosition: {
    lat: number;
    lng: number;
  };
}

// Get model data based on modelCode and modelOption.
export const fetchModelData = async (
  modelCode: string,
  modelOption: string
): Promise<VehicleDataFormatted | false> => {
  try {
    const province = generalController.getMetatagValue('province');
    const langCode = generalController.detectLanguage();

    const response = await handleRequest<{ status: number; data: ModelSearchResponse; message: string }>('get',
      `${getEndpointUrl('model-search')}/${modelCode}/${modelOption}?lang_code=${langCode}&prov_code=${province}`);

    if (response && response.data) {
      const { model_year, carline, financial, year, visual } = response.data;

      const vehicleDataFormatted: VehicleDataFormatted = {
        id: model_year.id,
        isEV: model_year.is_ev,
        title: carline.title,
        slug: carline.url_slug,
        model: carline.voi_leads_name,
        msrp: financial.msrp,
        year: year.url_slug,
        description: model_year.description,
        visual: {
          ...visual,
          jelly: model_year.jelly,
          jelly_hover: model_year.jelly_hover,
          jelly_path: model_year.jelly_path,
        }
      };

      console.log(vehicleDataFormatted);

      return vehicleDataFormatted;
    }

    return false;
  } catch (err) {
    console.log('Error ', err);
    return false;
  }
};

// Get dealer data based on dealer id.
export const fetchDealerData = async (dealerId: string): Promise<DealerDataWithPosition | false> => {
  try {
    const dealerData = await handleRequest<Dealer>('get', `${getEndpointUrl('get-dealer')}/${dealerId}`);

    if (dealerData) {
      return {
        dealer: dealerData,
        userPosition: {
          lat: dealerData.latitude || 0,
          lng: dealerData.longitude || 0,
        }
      };
    }

    return false;
  } catch (err) {
    console.error('Error ', err);
    return false;
  }
};
